/** 日志类型枚举，对应后端 /api/log 的 type 参数 */
export const LogType = {
  UNKNOWN: 0,
  RECHARGE: 1,
  CONSUMPTION: 2,
  ADMIN: 3,
  SYSTEM: 4,
  ERROR: 5,
  REFUND: 6,
  CALLING: 7,
} as const;

export type LogTypeValue = (typeof LogType)[keyof typeof LogType];
